import { StatusDefinition, StatusType } from "./statusTypes";

export const STATUS_DEFINITIONS: Record<StatusType, StatusDefinition> = {
  not_due: {
    type: "not_due",
    label: "Not Due",
    tooltip: "The test due date is in the future.",
    compliancePriority: 0,
  },
  due: {
    type: "due",
    label: "Due",
    tooltip: "The test is due today.",
    compliancePriority: 1,
  },
  overdue: {
    type: "overdue",
    label: "Overdue",
    tooltip: "The test due date has passed.",
    compliancePriority: 4,
  },
  pending: {
    type: "pending",
    label: "Pending",
    tooltip: "The test due date is in the future.",
    compliancePriority: 3,
  },
  missed: {
    type: "missed",
    label: "Missed",
    tooltip: "The test was not completed by the due date.",
    compliancePriority: 5,
  },
  incomplete: {
    type: "incomplete",
    label: "Incomplete",
    tooltip: "Some required subtests were not completed.",
    compliancePriority: 4,
  },
  skipped: {
    type: "skipped",
    label: "Skipped",
    tooltip: "The test was intentionally skipped.",
    compliancePriority: 2,
  },
  complete: {
    type: "complete",
    label: "Complete",
    tooltip: "All required tests were completed for this cycle.",
    compliancePriority: 0,
  },
  pass: {
    type: "pass",
    label: "Pass",
    tooltip: "The test result passed.",
    resultPriority: 1,
  },
  fail: {
    type: "fail",
    label: "Fail",
    tooltip: "The test result failed.",
    resultPriority: 3,
  },
  failed_resolved: {
    type: "failed_resolved",
    label: "Failed & Resolved",
    tooltip: "The test failed but the issue has been resolved.",
    resultPriority: 2,
  },
  excluded: {
    type: "excluded",
    label: "Excluded",
    tooltip: "This test run was excluded from consideration.",
  },
};

export function getStatusDefinition(status: StatusType): StatusDefinition {
  return STATUS_DEFINITIONS[status] ?? STATUS_DEFINITIONS.pending;
}
